import React, { lazy, Suspense, useCallback, useRef, useState } from "react";
import { SubHeading } from "../../shared/Components";
import CommonModal from "../../shared/Components/Modal/CommonModal";
import FormModal from "../../shared/Components/Modal/ConfigurationModal/FormModal";
import { getAxios } from "../../shared/Services/commonService";
import { API_FORM } from "../../utils/api/ApiConstant";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

const ConfigFormBody = lazy(() => import("./ConfigFormBody"));
const ConfigForm = () => {
  const LoggedInUserId = useSelector((state) => state.user?.user?.id);
  const parentIdListRef = useRef([]);

  // const fetchData = useCallback(async () => {
  //   const response = await getAxios(API_GET_FORM);
  //   return response;
  // }, []);

  const {
    data,
    isLoading,
    refetch: formRefetch,
  } = useQuery({
    queryKey: ["configFormData", LoggedInUserId],
    queryFn: () => getAxios(API_FORM),
    enabled: !!LoggedInUserId,
  });

  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  const handleModal = (rowData, title = "") => {
    setIsShow({
      isOpen: true,
      modalContent: FormModal,
      modalTitle: title,
      rowData,
    });
  };

  return (
    <>
      <SubHeading
        isAdd={true}
        handleShowHide={() =>
          handleModal({ parentIdList: parentIdListRef.current }, "Create")
        }
      />

      <Suspense fallback={<div>Loading...</div>}>
        <ConfigFormBody
          onEdit={(rowData) => handleModal(rowData, "Edit")}
          fetchData={formRefetch}
          data={data}
          isLoading={isLoading}
          onParentIdList={(list) => (parentIdListRef.current = list)}
        />
      </Suspense>
      {isShow?.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          size="lg"
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleModalHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                  apiFlag: !prev.apiFlag,
                })),
              rowData: {
                ...isShow.rowData,
                parentIdList: parentIdListRef.current,
              },
              fetchData: formRefetch,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default ConfigForm;
